import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter} from "react-router-dom";
import {createStore} from "redux";
import reportWebVitals from './reportWebVitals';
import './index.css';
import App from './App';
import rootReducer from "./modules";
import {Provider} from "react-redux";

const store = createStore(rootReducer)

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <HashRouter>
                <App/>
            </HashRouter>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
